import React from 'react';
import {useLocation} from "react-router-dom";
import ReactModal from 'react-modal';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSpinner } from '@fortawesome/free-solid-svg-icons';
import { useSystemMessage } from '../../../hooks/useSystemMessage';
import { taskcommentApi } from '../../../apis/taskcomment/taskcommentApi';
import icon05 from '../../../assets/images/ROOM_TaskFile_Re_05.png';
import { TaskComment } from '../../../types/types';
import {logError} from "../../../libs/utils/logError";
import useAppRouter from "../../../hooks/useAppRouter";

interface DeleteTaskCommentModalProps {
  taskComment: TaskComment;
  onSubmitted: () => Promise<void>;
}

export const DeleteTaskCommentModal = (props: DeleteTaskCommentModalProps) => {
  const { taskComment, onSubmitted } = props;
  const { success } = useSystemMessage();
  const location = useLocation();
  const { goto } = useAppRouter();
  const [disabled, setDisabled] = React.useState<boolean>(false);

  const handleSubmit = async () => {
    setDisabled(true);
    try {
      await taskcommentApi.delete(taskComment.id, {});
      setDisabled(false);
      await success('コメントを削除しました');
      await onSubmitted();
    } catch(e) {
      await logError(
        location.pathname,
        'コメントの削除に失敗しました。',
        e
      );

      goto('internalServerError');
    }
  };

  return (
    <>
      <ReactModal
        isOpen
        ariaHideApp={false}
        onRequestClose={() => onSubmitted()}
        className="content"
        overlayClassName="overlay"
        shouldCloseOnOverlayClick
      >
        <div className="form-modal-container">
          <div className="form-modal-title">
            <h1 className="font-semibold">コメント削除</h1>
            <button
              type="button"
              className="modal-close-btn"
              onClick={() => onSubmitted()}
            >
              <img src={icon05} alt="icon" />
            </button>
          </div>
          <div className="form-modal-content text-center">
            <h1 className="text-primary text-xl font-semibold">
              {`「${taskComment.content}」を削除しますか？`}
            </h1>
          </div>
          <div className="form-modal-footer-container">
            <div className="form-modal-footer">
              <button
                className="btn-sub"
                type="button"
                onClick={() => onSubmitted()}
              >
                キャンセル
              </button>
              <button
                className="btn-primary"
                type="button"
                onClick={handleSubmit}
                disabled={disabled}
              >
                {disabled ? (
                  <>
                    <FontAwesomeIcon
                      icon={faSpinner}
                      className="animate-spin mr-4"
                    />
                    削 除
                  </>
                ) : (
                  '削　除'
                )}
              </button>
            </div>
          </div>
        </div>
      </ReactModal>
    </>
  );
};
